var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"language-choice-container"},[_c('button',{staticClass:"language-choice",class:_vm.language.selected ? null : 'language-choice-deselected'},[_c('font',[_vm._v(" "+_vm._s(_vm.language.code.toUpperCase())+" ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }